(function() {
  var AccessController,
    bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  AccessController = App.loadClass('admin::Angular/AccessController');

  exports.GenerateKeyFieldsController = (function(superClass) {
    extend(GenerateKeyFieldsController, superClass);

    function GenerateKeyFieldsController(scope, transitions, data, http) {
      this.scope = scope;
      this.transitions = transitions;
      this.data = data;
      this.http = http;
      this["delete"] = bind(this["delete"], this);
      this.save = bind(this.save, this);
      this.generate = bind(this.generate, this);
      this.disableSave = bind(this.disableSave, this);
      GenerateKeyFieldsController.__super__.constructor.call(this, 'generate_key_fields', this.http);
      this.scope.fullpage = true;
      this.scope.title = 'Generate Key Fields';
      this.scope.absolute_errors = true;
      this.scope.options = {
        company: null,
        advisor: null,
        year: null,
        algorithm: null
      };
      this.scope.acres = '';
      this.scope.samples = '';
      this.scope.fields = [];
      this.scope.years = {};
      this.scope.algorithms = {};
      this.scope.saveEnabled = false;
      this.scope.disableSave = this.disableSave;
      this.scope.generate = this.generate;
      this.scope.save = this.save;
      this.scope["delete"] = this["delete"];
      this.loadScopeData(this.data.getCompanies(), 'companies');
      this.loadScopeData(this.data.getYears(), 'years');
      this.loadScopeData(this.data.getAlgorithms(), 'algorithms');
    }

    GenerateKeyFieldsController.prototype.disableSave = function() {
      return this.scope.saveEnabled = false;
    };

    GenerateKeyFieldsController.prototype.generate = function(options) {
      this.scope.saveEnabled = false;
      return this.data.buildMatViews(options.company.id, options.advisor.id, options.year, options.algorithm).then((function(_this) {
        return function(response) {
          var ref;
          _this.setAlert((ref = response.data) != null ? ref.status : void 0);
          return _this.data.generate(options.company.id, options.advisor.id, options.year, options.algorithm).then(function(response) {
            var ref1, ref2, ref3, ref4, ref5, ref6, ref7;
            _this.setAlert((ref1 = response.data) != null ? ref1.status : void 0);
            _this.scope.acres = (ref2 = response.data) != null ? (ref3 = ref2.data) != null ? ref3.acres : void 0 : void 0;
            _this.scope.samples = (ref4 = response.data) != null ? (ref5 = ref4.data) != null ? ref5.samples : void 0 : void 0;
            _this.scope.fields = (ref6 = response.data) != null ? (ref7 = ref6.data) != null ? ref7.fields : void 0 : void 0;
            return _this.scope.saveEnabled = true;
          });
        };
      })(this));
    };

    GenerateKeyFieldsController.prototype.save = function(options) {
      return this.data.saveKeyFields(options.company.id, options.advisor.id, options.year, this.scope.fields).then((function(_this) {
        return function(response) {
          var ref;
          return _this.setAlert((ref = response.data) != null ? ref.status : void 0);
        };
      })(this));
    };

    GenerateKeyFieldsController.prototype["delete"] = function(options) {
      return this.data.deleteKeyFields(options.company.id, options.advisor.id, options.year).then((function(_this) {
        return function(response) {
          var ref;
          return _this.setAlert((ref = response.data) != null ? ref.status : void 0);
        };
      })(this));
    };

    return GenerateKeyFieldsController;

  })(AccessController);

}).call(this);
